import axios from "axios";
import { getAuthorizationToken } from "../config/user";
const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
const REACT_APP_PROCESSING_API_URL = process.env.REACT_APP_PROCESSING_API_URL;

function uploadTpaCard(data) {
  return axios({
    method: "post",
    url: `${REACT_APP_PROCESSING_API_URL}/tpa-cards/read`,
    data: data,
    // headers:getAuthorizationToken('form-data')
  });
}
function uploadPatientCards(data) {
  return axios({
    method: "post",
    url: `${REACT_APP_PROCESSING_API_URL}/patient-cards/read`,
    data: data,
    // headers:getAuthorizationToken('form-data')
  });
}
function uploadAdmissionInitiateRefDoc(data) {
  return axios({
    method: "post",
    url: `${REACT_APP_PROCESSING_API_URL}/process`,
    data: data,
    // headers:getAuthorizationToken('form-data')
  });
}
function uploadEnhancementInitiateRefDoc(data) {
  return axios({
    method: "post",
    url: `${REACT_APP_PROCESSING_API_URL}/enhancement`,
    data: data,
    // headers:getAuthorizationToken('form-data')
  });
}
function uploadDischargeInitiateRefDoc(data) {
  return axios({
    method: "post",
    url: `${REACT_APP_PROCESSING_API_URL}/discharge`,
    data: data,
    // headers:getAuthorizationToken('form-data')
  });
}

export const ProcessingServices = {
  uploadTpaCard,
  uploadPatientCards,
  uploadAdmissionInitiateRefDoc,
  uploadEnhancementInitiateRefDoc,
  uploadDischargeInitiateRefDoc,
};
